const queue = require('./vendor/queue.min');

const composer = {
  version: "0.0.1",
  debug: false,
  floodmask: [0x01, 0x02, 0x04],
  currentLevel: 1
};

if (typeof module === "undefined") exports.composer = composer;
else module.exports = composer;

/*
 * The most basic compose operation takes a "stack" of images, e.g.:
 *
 * [
 *  {source: <Image>}
 *  {source: <Image>, alpha: 50}
 * ]
 *
 * To composite groups of images (e.g., to mask one image with another then
 * draw the result onto a lower layer), specify the "source" of the layer as
 * an array of sources:
 *
 * [
 *  {source: <Image>},
 *  {source: [
 *    {source: <Image>, comp: "source-in"},
 *    {source: <image>, comp: "source-out"}
 *  ], alpha: .5}
 * ]
 */

// unprotected: [0x01,  0x03,  0x07,   0xF,  0x1F,  0x3F,   0x7F,   0xFF,  0x1FF, 0x3FF];
//   protected: [0x400,0xC00,0x1C00,0x3C00,0x7c00,0xFC00,0x1FC00,0x3FC00,0x7FC00,0xFFC00];
//var floodmask = [0x401,0xC03,0x1C07,0x3C0F,0x7C1F,0xFC3F,0x1FC7F,0x3FCFF,0x7FDFF,0xFFFFF];

composer.level = function(level) {
  this.currentLevel = level;
};

composer.compose = function(stack, canvas, depth) {
  if (!Array.isArray(stack)) {
    throw "stack must be an Array (got: " + typeof stack + ")";
  }
  depth = depth || 0;
  var timerKey = "queue.compose [" + depth + "]";
  if (composer.debug) console.time(timerKey);

  var hasSize = true;
  if (!canvas) {
    canvas = document.createElement("canvas");
    hasSize = false;
  }
  var ctx = canvas.getContext("2d");
  var self = this;
  stack.forEach(function(layer, i) {
    if (!layer || typeof layer !== "object") {
      throw "stack layers must be objects (got " + layer + ")";
    }

    var source = layer.source;
    if (!source) return; // XXX throw error?

    if (source instanceof Array) {
      source = self.compose(source, null, depth + 1);
    }
    if (!hasSize) {
      canvas.width = source.width;
      canvas.height = source.height;
      hasSize = true;
    }

    if (layer.bitmask) {
      if (self.currentLevel === 0 && layer.name !== "waterMask") {
        // for (var i = 0; i < imageData.data.length; i += 4) {
        //   imageData.data[i + 0] = 255;
        //   imageData.data[i + 1] = 255;
        //   imageData.data[i + 2] = 255;
        //   imageData.data[i + 3] = 0;
        // }
        return;
      }

      var tmpCanvas = document.createElement("canvas");
      tmpCanvas.width = 256;
      tmpCanvas.height = 256;
      var tmpContext = tmpCanvas.getContext("2d");
      tmpContext.drawImage(source, 0, 0);
      var imageData = tmpContext.getImageData(0,0,256,256);

      var mask = self.floodmask[self.currentLevel - 1];

      for (var i=0; i < imageData.data.length; i += 4) {

        var val = (imageData.data[i] << 16) + (imageData.data[i + 1] << 8) + imageData.data[i + 2];

        // Use flood color when both tidelthresh and tidelcontiglevees
        // show the pixel as flooded
        if ((mask & val) && ((mask << 8) & val)) {
          if (layer.name === "flooding-color") {
            imageData.data[i + 0] = 78;
            imageData.data[i + 1] = 218;
            imageData.data[i + 2] = 234;
            // See comments in composer-risk about testing for inland water.
            // A particular value is encoded in the floodmaps for inland water bodies.
            // Originally these appeared blue like everything else, but now that there's
            // a new color, we have to test for this value in the floodmaps and make the
            // green layer fully transparent for such values.
            if (val === 16383) {
              imageData.data[i + 3] = 0; // fully transparent, no green
            } else {
              imageData.data[i + 3] = 63; // translucent green
            }
          } else {
            imageData.data[i + 3] = 255; // this will eat the destination tile
          }
        // If tidelthresh only shows the pixel flooded, the area
        // is protected or isolated. Color green with stippling.
        } else if (mask & (val >> 8)) {
          if (layer.name === "flooding-color") {
            imageData.data[i + 0] = 0;
            imageData.data[i + 1] = 255;
            imageData.data[i + 2] = 118;

            var px = Math.floor(i / 4),
                row = Math.floor(px / 256),
                col = px % 256;
            if ((row % 2) === 0 && (col % 2) === 0) {
              imageData.data[i + 3] = 192;
            } else {
              imageData.data[i + 3] = 63;
            }
          } else {
            imageData.data[i + 3] = 255;
          }
        } else {
          imageData.data[i + 3] = 0;
        }
      }
      tmpContext.putImageData(imageData, 0, 0);
      source = tmpCanvas;
    }

    ctx.globalAlpha = isNaN(layer.alpha) ? 1 : layer.alpha / 100;
    ctx.globalCompositeOperation = layer.comp || "source-over";
    try {
      ctx.drawImage(source, 0, 0);
    } catch (err) {
      // console.warn("composite error:", err, source, source.complete, source.src);
    }
  });
  if (composer.debug) console.timeEnd(timerKey);
  return canvas;
};

/*
 * The composer queue acts like a queue(), but knows low to asynchronously
 * load stack images by URL, e.g.:
 *
 * var stack = [
 *  {url: "foo.png"},
 *  {url: "bar.png", comp: "xor"}
 * ];
 * var canvas = document.createElement("canvas");
 * composer.queue()
 *  .load(stack, function(error, images) {
 *    if (!error) composer.compose(stack, canvas);
 *  });
 *
 * or let the queue handle composing for you (asynchronously):
 *
 * composer.queue()
 *  .compose(stack, canvas);
 *
 * By default, the queue looks for layer urls in the "url" property of each
 * layer object. You can configure how URLs are read from each layer in the
 * stack. null or empty URLs are skipped.
 *
 * var urls = {
 *  "mask": "images/mask.png",
 *  "content": "images/sky.jpg"
 * };
 * var stack = [
 *  {name: "mask", comp: "source-out"},
 *  {name: "content", comp: "source-in"}
 * ];
 * composer.queue()
 *  .url(function(layer) { return urls[layer.name]; })
 *  .compose(stack, canvas);
 */
composer.queue = function(parallelism) {
  var self = this;

  var q = queue(parallelism || Infinity),
      requests = [],
      url = function(layer) {
        return layer.url;
      },
      loadImage = self.load.image,
      enqueue = function(layer, callback) {
        var u = url(layer);
        if (!u) return; // don't load if there's no URL
        var req = loadImage.call(self, u, function(error, image) {
          layer.source = image;
          callback.apply(this, arguments);
        });
        /*
         var req = loadImage(u, function(error, image) {
         layer.source = image;
         callback.apply(this, arguments);
         });
         */
        requests.push(req);
      };

  q.url = function(fn) {
    if (!arguments.length) return url;
    url = functor(fn);
    return q;
  };

  q.load = function(stack, callback) {
    self.eachLayer(stack, function(layer) {
      q.defer(enqueue, layer);
    });
    if (self.debug) console.time("queue.load");
    return q.awaitAll(function(error, images) {
      if (self.debug) console.timeEnd("queue.load");
      callback.call(null, error, stack, images);
      requests = [];
    });
  };

  q.compose = function(stack, canvas) {
    return q.load(stack, function(error, images) {
      if (!error) self.compose(stack, canvas);
      if (callback) callback.call(null, error, stack, images);
    });
  };

  q.abort = function() {
    var req;
    while (requests.length) (req = requests.shift()) && req.abort();
  };

  return q;
};

composer.load = {
  loading: 0
};

/*
 * Load an image URL and execute the callback on load or on error.
 */
composer.load.image = function(url, callback) {
  var self = this;
  if (self.cache.has(url)) {
    setTimeout(function() {
      var image = self.cache.get(url);
      callback.call(null, null, image);
    }, 1);
    return;
  }

  self.load.loading++;
  // Workaround: http://stackoverflow.com/questions/16956295/ie10-and-cross-origin-resource-sharing-cors-issues-with-image-canvas
  var xhr = new XMLHttpRequest();

  xhr.onload = function () {
    var obj_url = URL.createObjectURL(this.response), img = new Image();
    img.onload = function () {
      self.cache.set(url, img);
      self.load.loading--;
      callback.call(null, null, img);
      URL.revokeObjectURL(obj_url);
    };
    img.abort = function() {
      self.load.loading--;
      img.onload = img.onerror = noop;
    };
    img.src = obj_url;
  };
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.send();
};

/*
 * Call a function for each layer in a stack, recursing as it finds nested
 * sources, and return the "flattened" layers as an array.
 */
composer.eachLayer = function(stack, callback) {
  var self = this;
  var layers = [];
  stack.forEach(function(layer) {
    if (layer.source instanceof Array) {
      var sublayers = self.eachLayer(layer.source, callback);
      layers = layers.concat(sublayers);
    } else {
      if (callback) callback.call(null, layer);
      layers.push(layer);
    }
  });
  return layers;
};

/*
 * The composer cache is a static key/value store for keeping images in
 * memory, which drastically speeds up compositing lots of images by URL.
 */
composer.cache = (function() {
  var cache = {},
      values = {},
      keys = [],
      size = 1024;

  cache.has = function(key) {
    return values.hasOwnProperty(key);
  };

  cache.set = function(key, value) {
    if (size <= 0) return value;
    if (!values.hasOwnProperty(key)) {
      keys.push(key);
    }
    values[key] = value;
    trim();
    return value;
  };

  cache.get = function(key) {
    return values[key];
  };

  cache.del = function(key) {
    var index = keys.indexOf(key),
        value = values[key];
    delete values[key];
    keys.splice(index, 1);
    return value;
  };

  cache.length = function() {
    return keys.length;
  };

  cache.size = function(len) {
    if (!arguments.length) return size;
    size = len;
    trim();
    return cache;
  };

  cache.flush = function() {
    keys = [];
    values = {};
    return cache;
  };

  function trim() {
    while (keys.length > size) {
      var key = keys.shift();
      delete values[key];
    }
    return cache;
  }

  return cache;
})();

composer.cache.emptyUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

function functor(n) {
  return (typeof n === "function") ? n : function() { return n; };
}

function noop() {}
